import { IPackage } from '../types';

export function selectPackageById(packagesList: IPackage[], id: string): IPackage[] {
  return packagesList.map(item => {
    if (item.id === id) {
      return { ...item, selected: true };
    }

    return { ...item, selected: false };
  });
}
